import { defineStore } from 'pinia';

const defaultLanguage = {
  name: 'English',
  initials: 'EN',
  icon: 'flagpack:us',
};

function getSavedLanguage() {
  try {
    return JSON.parse(localStorage.getItem('language')) || defaultLanguage;
  } catch {
    localStorage.removeItem('language');
    return defaultLanguage;
  }
}

export const useUiStore = defineStore(`${process.env.VUE_APP_NAME}_uiStore`, {
  id: 'ui',
  state: () => ({
    colorMode: localStorage.getItem('colorMode') || 'light',
    language: getSavedLanguage(),
  }),
  persist: true,
  actions: {
    setColorMode(mode) {
      this.colorMode = mode;
      localStorage.setItem('colorMode', mode);
    },
    toggleColorMode() {
      this.setColorMode(this.colorMode === 'light' ? 'dark' : 'light');
    },
    setLanguage(lang) {
      this.language = lang;
      localStorage.setItem('language', JSON.stringify(lang));
    },
  },
});
